module.exports = __webpack_public_path__ + "static/media/APP_Scientist_152x174_6.38256395.png";